import React, { useState } from 'react';
import Popover, { ArrowContainer } from 'react-tiny-popover';
import { useHintContainer } from '../../../../context/useHintContainerContext';
import {
  Button,
  HintWarningContainer,
  WarningText,
  WarningSubText,
  WarningButton,
  WarningButtonContainer,
  Title,
  Container,
} from './styled';

const HintPopover = ({ active, showHint, toggleRenderWarning }) => {
  const { setShowWarning, addHintToVisble, removeHintFromQueue, queue } =
    useHintContainer();
  const [isPopOverOpen, SetIsPopOverOpen] = React.useState(false);

  const renderPopover = () => {
    if (active && toggleRenderWarning) {
      return active;
    } else {
      return isPopOverOpen;
    }
  };

  const testShowHint = () => {
    addHintToVisble();
    removeHintFromQueue();
    setShowWarning(false);
  };

  const showWarningText = () => {
    const hint = queue[0];
    if (hint && hint.warningText) {
      return hint.warningText;
    } else {
      return 'Deze hint bevat mogelijk de oplossing voor de ronde.';
    }
  };

  return (
    <Popover
      isOpen={renderPopover()}
      position={['top', 'right', 'left', 'bottom']}
      padding={10}
      onClickOutside={() => SetIsPopOverOpen({ isPopOverOpen: false })}
      content={({ position, targetRect, popoverRect }) => (
        <ArrowContainer
          position={position}
          targetRect={targetRect}
          popoverRect={popoverRect}
          arrowColor={'yellow'}
          arrowSize={10}
          arrowStyle={{ opacity: 0.7 }}
        >
          <HintWarningContainer>
            <WarningText>{showWarningText()}</WarningText>
            <WarningSubText>
              Weet je zeker dat je de hint wilt lezen?{' '}
            </WarningSubText>
            <WarningButtonContainer>
              <WarningButton value='Ja' onClick={testShowHint}>
                Ja
              </WarningButton>
              <WarningButton value='nee' onClick={() => setShowWarning(false)}>
                Nee
              </WarningButton>
            </WarningButtonContainer>
          </HintWarningContainer>
        </ArrowContainer>
      )}
    >
      <Container>
        <Title>Hints</Title>
        {active && (
          <>
            <Button onClick={showHint} active={active}>
              Hint beschikbaar
            </Button>
          </>
        )}
      </Container>
    </Popover>
  );
};

export default HintPopover;
